// extracted by mini-css-extract-plugin
export var quantityInput = "_q2-0";